import React, { useState } from "react";
import './styles/LocationScreen.css';
import './styles/CommonForAll.css';
import { useNavigate, useLocation } from 'react-router-dom';
import CurrentLocation from '../components/CurrentLocation';
import MapSelector from '../components/MapSelector';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
const LocationScreen = ({ user: propUser }) => {
  const { state } = useLocation();
  const user = state?.user || propUser || null;

  const [currentAddress, setCurrentAddress] = useState('');
  const [userLocation, setUserLocation] = useState(null);
  const [showMap, setShowMap] = useState(false);

  const navigate = useNavigate();

  const getAvailableProduct = () => {
    if (!userLocation) {
      alert("Please select or detect your location first.");
      return;
    }

    navigate('/availableproducts', {
      state: {
        location: userLocation,
        currentAddress: currentAddress,
        user
      }
    });
  };

  return (
    <div className="location-container">
      <div className="location-header">
        <div className="profile">
          <img
            src={user?.photoURL || 'https://via.placeholder.com/40'}
            alt="User"
            className="avatar"
          />
          <div className="profile-info">
            <h4>{user?.name || 'Guest'}</h4>
            <p>{user?.email || 'No email'}</p>
          </div>
        </div>
     <button onClick={handleLogout} className="logout-link">Log Out</button>

      </div>

      <p className="location-instruction">
        <em><strong>To provide the services, your location is required</strong></em>
      </p>

      <div className="location-display">
        <span className="location-icon">📍</span>
        {currentAddress && <>{currentAddress}<hr /></>}
      </div>

      <CurrentLocation
        onAddressRetrieved={(address, coords) => {
          setCurrentAddress(address);
          setUserLocation(coords);
          setShowMap(false);
        }}
      />

      <p className="or-text">OR</p>
      <button
        className="location-btn brown"
        onClick={() => setShowMap(!showMap)}
      >
        {showMap ? "Hide Map" : "Choose from Map"}
      </button>

      {showMap && (
        <MapSelector
          onLocationSelected={(address, coords) => {
            setCurrentAddress(address);
            setUserLocation(coords);
            setShowMap(false);
          }}
        />
      )}

      <button className="location-btn green" onClick={getAvailableProduct}>
        Continue
      </button>
    </div>
  );
};
const handleLogout = async () => {
  await signOut(auth);
  window.location.href = '/'; // refresh to go to welcome screen
};
export default LocationScreen;
